import styled from "styled-components";

const Overlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    min-width: 100vw;
    min-height: 100vh;
    background: rgba(0, 0, 0, 0.3);
    z-index: 9999;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`;

const ModalContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    padding: 20px;
    background: rgba(255, 255, 255, 0.95);
    border-radius: 16px;
    backdrop-filter: blur(10px);
    border: 1px solid rgba(255, 255, 255, 0.2);
    min-width: 350px;
`;

const ModalHeader = styled.div`
    padding: 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
`;

const ModalTitle = styled.h2`
    font-family: ${props => props.theme.typography.fontFamily};
    font-size: ${props => props.theme.typography.h6.fontSize};
    color: ${props => props.theme.colors.text.primary};
`;


const ModalContent = styled.div`
    width: 100%;
    text-align: center;
    white-space: pre-wrap;
`;

const ModalActions = styled.div`
    display: flex;
    justify-content: flex-end;
    width: 100%;
    gap: 8px;
`;

export const ActionButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  background: ${props => props.cancel === "true" ? "none" : props.theme.colors.gradients.primary};
  color: ${props => props.cancel === "true" ? props.theme.colors.primary.main : props.theme.colors.primary.contrastText};
  padding: 12px 20px;
  border: none;
  border-radius: ${props => props.theme.borderRadius.lg};
  cursor: pointer;
  font-size: ${props => props.theme.typography.button.fontSize};
  font-weight: ${props => props.theme.typography.fontWeightMedium};
  font-family: ${props => props.theme.typography.fontFamily};
  line-height: ${props => props.theme.typography.button.lineHeight};
  letter-spacing: ${props => props.theme.typography.button.letterSpacing};
  text-transform: ${props => props.theme.typography.button.textTransform};
  transition: all ${props => props.theme.transitions.duration.standard}ms ${props => props.theme.transitions.easing.easeInOut};
  box-shadow: ${props => props.cancel === "true" ? "none" : props.theme.shadows.sm};
  position: relative;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
    transition: left ${props => props.theme.transitions.duration.complex}ms ${props => props.theme.transitions.easing.easeInOut};
  }
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: ${props => props.theme.shadows.md};
    background: ${props => props.cancel === "true" ? props.theme.colors.gradients.warning : props.theme.colors.gradients.dark};
    color: ${props => props.theme.colors.primary.contrastText};
    
    &::before {
      left: 100%;
    }
  }
`;

const Modal = ({ isOpen, onClose, title, children, onConfirm, confirmButtonName, cancelButtonName }) => {
  if (!isOpen) return null;

  return (
    <Overlay>
      <ModalContainer>
        <ModalHeader>
          <ModalTitle>{title}</ModalTitle>
        </ModalHeader>
        <ModalContent>{children}</ModalContent>
        <ModalActions>
          {onClose && <ActionButton cancel={"true"} onClick={onClose}>{cancelButtonName}</ActionButton>}
          <ActionButton onClick={onConfirm}>{confirmButtonName}</ActionButton>
        </ModalActions>
      </ModalContainer>
    </Overlay>
  );
}

export default Modal;